module.exports = __webpack_public_path__ + "img/logo002.86ad45e4.png";